<script>
import Tweezer from 'tweezer.js';

export default {
  name: 'VideoCard',
  props: {
    source: {
      required: true,
      type: Object,
    },
  },
  created () {
    this.$watch('source', () => {
      this.getCacheVideoUrl();
    }, { immediate: true });
  },
  data: () => ({
    cacheVideoUrl: null,
    isGettingCachedVideo: false,
  }),
  computed: {
    cachedSource () {
      const { src, type } = this.source;
      return !this.isGettingCachedVideo && { src: this.cacheVideoUrl || `${src}?t=${new Date().getTime()}`, type };
    },
  },
  methods: {
    async getCacheVideoUrl () {
      this.isGettingCachedVideo = true;
      try {
        const result = await this.$store.dispatch('interop/getCachedFilePath', { url: this.source.src });
        this.cacheVideoUrl = result.localPath || result || null;
      } catch (e) {
        this.cacheVideoUrl = null;
      } finally {
        this.isGettingCachedVideo = false;
      }
    },
    rampupVolume () { // we async here cause in Chrome/Firefox play() returns a Promise that is rejected if video pause before play is resolved
      new Tweezer({
        start: 0,
        end: 50,
        duration: 1500,
      })
        .on('tick', val => {
          this.$el.volume = val / 100;
        })
        .begin();
    },
    stop () {
      new Tweezer({
        start: 50,
        end: 0,
        duration: 1000,
      })
        .on('tick', val => {
          this.$el.volume = val / 100;
        })
        .on('done', val => {
          this.$el.pause();
          this.$el.currentTime = 0;
        })
        .begin();
    },
  },
  beforeDestroy () {
    this.stop();
  },
  deactivated () {
    this.stop();
  },
};
</script>

<template lang="pug">
video.video-card(v-if="cachedSource" autoplay nocontrols loop @play="rampupVolume" crossorigin="anonymous")
  source(:src="cachedSource.src" :type="cachedSource.type")
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "styles/variables.css";
.video-card {
}
</style>
